import { injectable } from 'inversify';
import { IPriceProviderQuote, IPriceProviderService } from './price-provider.interface';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class PriceProviderMock implements IPriceProviderService {
    quoteObservable(): Observable<IPriceProviderQuote> {
        return NEVER;
    }
}
